<!-- 个人采购订单 -->
<template>
    <div class='page_content'>
        <div class="page_content_top">
            <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="refresh" :showRefresh="true" :buttonFlag="false"></v-button>

            <div class="page_content_top_line">
                <vSearch :flagList="['planId']" @searchData="getDataList" :getRequestData=getRequestData v-if="formList.internalAccountManger" :searchList=formList.internalAccountManger>
                    <template slot="searchInput">
                        <el-select v-model="getRequestData.planId" placeholder="请选择账套" filterable @change="changeSelect">
                            <el-option v-for="item in planList" :key="item.planId" :label="item.planName" :value="item.planId"></el-option>
                        </el-select>
                    </template>
                </vSearch>

            </div>
        </div>
        <div class="">
            <div class="dis">
                <el-radio-group v-model="accountSel" style="margin-top:2px;" @change="acc">
                    <el-radio label="1">只生成一张凭证</el-radio>
                    <el-radio label="2">每笔生成一张凭证</el-radio>
                </el-radio-group>
                <el-checkbox-group v-model="mutipleSel" style="margin-left: 30px;">
                    <el-checkbox label="3" :disabled="isDis">合并相同科目</el-checkbox>
                    <el-checkbox label="4">忽略借贷金额同为零的记录</el-checkbox>
                </el-checkbox-group>
                <div class="num">
                    <div class="money">
                        <span>含税金额：</span>
                        <span class="ttred">{{ totalPsMoney }}</span>
                    </div>
                    <div class="money">
                        <span>记录数：</span>
                        <span class="ttred">{{ totalSelLength }}</span>
                    </div>
                </div>
            </div>
            <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
                <el-tab-pane label="原始数据" name="first">
                    <div class="page_content_center">
                        <!-- @selection-change="handleSelectionChange" -->
                        <u-table ref="plTable" :row-height="35" :height="tableHeight" row-key="index" use-virtual :big-data-checkbox="true" highlight-current-row size="mini" @select="handleSelect" @select-all="handleSelectAll" border>
                            <u-table-column type="selection" width="40" />
                            <u-table-column align="center" v-for="(tableValye, tableKey) in rawField" :key="tableKey" :sortable="tableValye.field == 'dwmch'||tableValye.field == 'hsje' ? true : false" show-overflow-tooltip
                                :prop="tableValye.field" :label="tableValye.label" :min-width="tableValye.width" />
                        </u-table>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="原始数据(已勾选)" name="first1">
                    <div class="page_content_center">
                        <!-- @selection-change="handleSelectionChange" -->
                        <u-table :data="multipleSelection" :row-height="35" :height="tableHeight" row-key="index" use-virtual :big-data-checkbox="true" highlight-current-row size="mini" border>
                            <u-table-column align="center" v-for="(tableValye, tableKey) in rawField" :key="tableKey" :sortable="tableValye.field == 'dwmch'||tableValye.field == 'hsje' ? true : false" show-overflow-tooltip
                                :prop="tableValye.field" :label="tableValye.label" :min-width="tableValye.width" />
                            <u-table-column width="80" label="操作" fixed="right">
                                <template slot-scope="scope">
                                    <el-button type="text" @click="delClick(scope)" style="color:red;">删除</el-button>
                                </template>
                            </u-table-column>
                        </u-table>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="凭证" name="second">
                    <div class="page_content_center">
                        <u-table ref="plTable1" :row-height="35" :height="tableHeight" row-key="index" use-virtual highlight-current-row size="mini" border>
                            <u-table-column align="center" v-for="(tableValye, tableKey) in fieldJson" :key="tableKey" show-overflow-tooltip :prop="tableValye.field" :label="tableValye.label" :min-width="tableValye.width">
                                <template slot-scope="scope">
                                    <span>{{ scope.row[tableValye.dataSource] }}</span>
                                </template>
                            </u-table-column>
                        </u-table>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import Vue from "vue";
import formList from "./voucher";
export default {
    //import引入的组件需要注入到对象中才能使用
    components: {},
    data() {
        //这里存放数据
        return {
            tableHeight: 500,
            getRequestData: { // 查询条件
                start: new Date(new Date().toLocaleDateString()).getTime() - 31 * 24 * 3600 * 1000, // 开始时间
                end: new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000 - 1, // 结束时间
                planId: '', //方案Id
                searchValue: ''
                // planName: '' // 方案名称
            },
            buttonList: [], //权限按钮集合
            activeName: '', // tab选择项
            mutipleSel: ['3'], // 多选选项
            accountSel: '1', // 单选选项
            // 原始数据字段
            rawField: [
                {
                    label: '单据编号',
                    field: 'djbh',
                    width: 150,
                },
                {
                    label: '日期',
                    field: 'rq',
                    width: 120,
                },
                {
                    label: '业务员',
                    field: 'ywy',
                    width: 120,
                },
                {
                    label: '单位名称',
                    field: 'dwmch',
                    width: 160,
                },
                {
                    label: '含税金额',
                    field: 'hsje',
                    width: 120,
                },
                {
                    label: '部门名称',
                    field: 'bm',
                    width: 120,
                },
                {
                    label: '操作员',
                    field: 'username',
                    width: 120,
                },
                {
                    label: '摘要',
                    field: 'zhy',
                    width: 200,
                },
                {
                    label: '记账类型',
                    field: 'name1',
                    width: 120,
                },
                {
                    label: '凭证类别',
                    field: 'code1',
                    width: 120,
                }

            ],
            // 凭证字段
            voucherField: [
                {
                    label: '凭证类型',
                    field: 'pzlx',
                    width: 120,
                },
                {
                    label: '日期',
                    field: 'rq',
                    width: 120,
                },
                {
                    label: '单据编号',
                    field: 'djbh',
                    width: 150,
                },
                {
                    label: '摘要',
                    field: 'Summary',
                    width: 200,
                },
                {
                    label: '科目号',
                    field: 'Account',
                    width: 120,
                },
                {
                    label: '含税金额',
                    field: 'hsje',
                    width: 120,
                },
                {
                    label: '借方金额',
                    field: 'AmountDr',
                    width: 120,
                },
                {
                    label: '贷方金额',
                    field: 'AmountCr',
                    width: 120,
                },
                {
                    label: '业务员',
                    field: 'ywy',
                    width: 120,
                },
                {
                    label: 'Currency',
                    field: 'Currency',
                    width: 120,
                },
                {
                    label: 'AuxAccCustomer',
                    field: 'AuxAccCustomer',
                    width: 120,
                },
                {
                    label: 'AuxAccPerson',
                    field: 'AuxAccPerson',
                    width: 120,
                },
                {
                    label: 'AuxAccDepartment',
                    field: 'AuxAccDepartment',
                    width: 120,
                }
            ],
            planList: [], // 所有方案集合
            rawData: [], // 原始数据列表
            voucherData: [], // 凭证数据列表
            multipleSelection: [], // 原始数据选择项
            detailsList: [],
            postlist: [],
            fieldJson: [
                {
                    dataSource: 'djbh', //数据源字段
                    voucherField: 'ExternalCode', //凭证字段
                    groupType: 'hz', //分组类别
                    jdfx: 'wu', //借贷方向
                    isCode: false, //IsCode
                    isAuxInfos: false, //IsAuxInfos
                    label: '凭证单号',
                    width: 150,
                },
                {
                    dataSource: 'rq',
                    voucherField: 'VoucherDate',
                    groupType: 'hz',
                    jdfx: 'wu',
                    isCode: false,
                    isAuxInfos: false,
                    label: '日期',
                    width: 110,
                },
                {
                    dataSource: 'zhy',
                    voucherField: 'Summary',
                    groupType: 'mx',
                    jdfx: 'all',
                    isCode: false,
                    isAuxInfos: false,
                    label: '摘要',
                    width: 200,
                },
                {
                    dataSource: 'kemuhao',
                    voucherField: 'Account',
                    groupType: 'mx',
                    jdfx: 'all',
                    isCode: true,
                    isAuxInfos: false,
                    label: '科目号',
                    width: 100,
                },
                {
                    dataSource: 'jfje',
                    voucherField: 'AmountDr',
                    groupType: 'mx',
                    jdfx: 'jf',
                    isCode: false,
                    isAuxInfos: false,
                    label: '借方金额',
                    width: 120,
                },
                {
                    dataSource: 'dfje',
                    voucherField: 'AmountCr',
                    groupType: 'mx',
                    jdfx: 'df',
                    isCode: false,
                    isAuxInfos: false, //return item.dataSource == i && item.groupType == 'mx' && (jdfx == item.jdfx || item.jdfx == 'all')
                    label: '贷方金额',
                    width: 120,
                },
                {
                    dataSource: 'auxacccustomer',
                    voucherField: 'AuxAccCustomer',
                    groupType: 'mx',
                    jdfx: 'all',
                    isCode: true,
                    isAuxInfos: true,
                    label: '单位编码',
                    width: 120,
                },
                {
                    dataSource: 'auxaccdepartment',
                    voucherField: 'AuxAccDepartment',
                    groupType: 'mx',
                    jdfx: 'all',
                    isCode: true,
                    isAuxInfos: true,
                    label: '部门',
                    width: 120,
                },
                {
                    dataSource: 'auxaccperson',
                    voucherField: 'AuxAccPerson',
                    groupType: 'mx',
                    jdfx: 'all',
                    isCode: true,
                    isAuxInfos: true,
                    label: '人员',
                    width: 120,
                },
                {
                    dataSource: 'auxaccinventorycode',
                    voucherField: 'AuxAccInventory',
                    groupType: 'mx',
                    jdfx: 'all',
                    isCode: true,
                    isAuxInfos: true,
                    label: '商品编码',
                    width: 130,
                },
                {
                    dataSource: 'quantitydr',
                    voucherField: 'QuantityDr',
                    groupType: 'mx',
                    jdfx: 'jf',
                    isCode: false,
                    isAuxInfos: false,
                    label: '借方数量',
                    width: 120,
                },
                {
                    dataSource: 'quantitycr',
                    voucherField: 'QuantityCr',
                    groupType: 'mx',
                    jdfx: 'df',
                    isCode: false,
                    isAuxInfos: false,
                    label: '贷方数量',
                    width: 120,
                },
                {
                    dataSource: 'price',
                    voucherField: 'Price',
                    groupType: 'mx',
                    jdfx: 'all',
                    isCode: false,
                    isAuxInfos: false,
                    label: '单价',
                    width: 120,
                },
                {
                    dataSource: 'unitName',
                    voucherField: 'Unit',
                    groupType: 'mx',
                    jdfx: 'all',
                    isCode: false,
                    isAuxInfos: false,
                    label: '包装单位',
                    width: 120,
                },
                {
                    dataSource: 'currency',
                    voucherField: 'Currency',
                    groupType: 'mx',
                    jdfx: 'all',
                    isCode: true,
                    isAuxInfos: false,
                    label: '货币',
                    width: 120,
                },
                {
                    dataSource: 'name',
                    voucherField: 'Name',
                    groupType: 'pzlb',
                    jdfx: 'wu',
                    isCode: false,
                    isAuxInfos: false,
                    label: '凭证类别名称',
                    width: 120,
                },
                {
                    dataSource: 'pzlx',
                    voucherField: 'Code',
                    groupType: 'pzlb',
                    jdfx: 'wu',
                    isCode: false,
                    isAuxInfos: false,
                    label: '凭证类别编码',
                    width: 120,
                },
            ],
            resList: [], //只生成一张凭证 明细结果集
            mxList: [], //每张生成一张凭证 明细结果集
            group: [],
            totalPsMoney: 0.00, // 总含税金额
            totalSelLength: 0, // 总数
            planId: '',
            rawDataIds: [], // 原始数据单据编号
            oldList: [],
            groupField: '',
            requesUrl: '',
            imgUrl: '',
            ormId: '',
            isDis: false,
            excelData: [],
            excelNamelist: [],
            formList: formList,
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
    },
    //方法集合
    methods: {
        //表格数据写入excel
        export2Excel() {
            this.excelData = JSON.parse(JSON.stringify(this.rawData))
            // this.excelNamelist = JSON.parse(JSON.stringify(this.fieldJson))
            this.excelNamelist = JSON.parse(JSON.stringify(this.rawField))
            var fieldList = []; //所有字段 显示的所有字段
            var namelist = [];
            this.excelNamelist.forEach(item => {
                // if (this.activeName == 'first') {
                //   fieldList.push(item.dataSource)
                // } else {
                //   fieldList.push(item.voucherField)
                // }
                namelist.push(item.label)
                fieldList.push(item.field)
            })
            console.log(this.rawField);
            console.log(namelist, fieldList);
            // 导出业务逻辑 引用封装好的js方法
            require.ensure([], () => {
                const {
                    export_json_to_excel
                } = require("@/assets/excel/Export2Excel");
                //这里使用绝对路径( @表示src文件夹 )，使用@/+存放export2Excel的路径
                const tHeader = namelist; // 导出的excel表头名信息
                const filterVal = fieldList; // 导出的excel表头字段名，需要导出表格字段名
                const list = this.excelData; // 查询的数据list
                // 进行数据json map 格式转换
                const data = this.formatJson(filterVal, list);
                // 调用方法传参      表头名信息 数据  导出的表格名称
                export_json_to_excel(tHeader, data, "凭证数据");


            });
        },
        //表格数据写入excel
        export3Excel() {
            this.excelData = JSON.parse(JSON.stringify(this.voucherData))
            this.excelNamelist = JSON.parse(JSON.stringify(this.fieldJson))
            // this.excelNamelist = JSON.parse(JSON.stringify(this.rawField))
            var fieldList = []; //所有字段 显示的所有字段
            var namelist = [];
            this.excelNamelist.forEach(item => {
                // if (this.activeName == 'first') {
                //   fieldList.push(item.dataSource)
                // } else {
                //   fieldList.push(item.voucherField)
                // }
                namelist.push(item.label)
                fieldList.push(item.dataSource)
            })
            console.log(this.rawField);
            console.log(namelist, fieldList);
            // 导出业务逻辑 引用封装好的js方法
            require.ensure([], () => {
                const {
                    export_json_to_excel
                } = require("@/assets/excel/Export2Excel");
                //这里使用绝对路径( @表示src文件夹 )，使用@/+存放export2Excel的路径
                const tHeader = namelist; // 导出的excel表头名信息
                const filterVal = fieldList; // 导出的excel表头字段名，需要导出表格字段名
                const list = this.excelData; // 查询的数据list
                // 进行数据json map 格式转换
                const data = this.formatJson(filterVal, list);
                // 调用方法传参      表头名信息 数据  导出的表格名称
                export_json_to_excel(tHeader, data, "凭证数据");


            });
        },
        //格式转换方法
        formatJson(filterVal, jsonData) {
            return jsonData.map((v) => filterVal.map((j) => v[j]));
        },
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.getRequestData.end = time;
            }
        },
        acc(e) {
            if (e == 1) {
                this.mutipleSel = ['3']
                this.isDis = false
            } else {
                this.mutipleSel = []
                this.isDis = true
            }
            console.log(this.accountSel)
        },
        // 单选改变
        changeSelect() {
            this.planList.forEach(item => {
                if (this.getRequestData.planId == item.planId) {
                    this.groupField = item.groupField
                }
            })
            this.multipleSelection = []
            this.getDataList()
        },
        // 刷新
        refresh() {
            this.activeName = 'first'
            this.resList = []
            this.voucherData = []
            this.getAllVoucherPlan()
            this.getButtonList()
        },
        //判断是否为对象（仅为对象，不是数组也不是null）
        isObject(exp) {
            return Object.prototype.toString.call(exp) == '[object Object]'
        },
        handleClick() {
            if (this.activeName == "first") {
                Promise.resolve(this.$refs.plTable.reloadData(this.rawData)).then(() => {
                    this.$nextTick(() => {
                        const pl = this.$refs.plTable
                        pl.clearSelection();
                        if (pl && this.multipleSelection.length) {
                            pl.toggleRowSelection(
                                this.multipleSelection.map(row => ({ row, selected: true }))
                            )
                        }
                        this.syncMultipleSelectionSummary()
                    })
                })
            }
        },
        delClick(scope) {
            var index = this.multipleSelection.indexOf(scope.row)
            this.multipleSelection.splice(index, 1)
        },
        // 原始数据两行是否为同一业务数据（整对象深度比对，不依赖单个字段）
        isSameRawRow(a, b) {
            if (a === b) return true
            if (a == null || b == null || typeof a !== 'object' || typeof b !== 'object') {
                return a === b
            }
            if (Array.isArray(a) !== Array.isArray(b)) return false
            if (Array.isArray(a)) {
                if (a.length !== b.length) return false
                for (let i = 0; i < a.length; i++) {
                    if (!this.isSameRawRow(a[i], b[i])) return false
                }
                return true
            }
            const keysA = Object.keys(a)
            const keysB = Object.keys(b)
            if (keysA.length !== keysB.length) return false
            for (let i = 0; i < keysA.length; i++) {
                const k = keysA[i]
                if (!Object.prototype.hasOwnProperty.call(b, k)) return false
                if (!this.isSameRawRow(a[k], b[k])) return false
            }
            return true
        },
        // 勾选合计金额与条数（与原先 selection-change 逻辑一致）
        syncMultipleSelectionSummary() {
            let total = 0
            this.multipleSelection.forEach(item => {
                total = NP.plus(total, Number(item.hsje || 0))
            })
            this.totalPsMoney = total
            this.totalSelLength = this.multipleSelection.length
        },
        // 表头全选 / 全不选（虚拟表格 val 为当前表格内的选中结果）
        handleSelectAll(val) {
            if (val && val.length) {
                val.forEach(row => {
                    const idx = this.multipleSelection.findIndex(item => this.isSameRawRow(item, row))
                    if (idx === -1) {
                        this.multipleSelection.push(row)
                    }
                })
            } else {
                this.multipleSelection = this.multipleSelection.filter(
                    sel => !this.rawData.some(r => this.isSameRawRow(r, sel))
                )
            }
            this.syncMultipleSelectionSummary()
        },
        // 单行勾选加入 / 取消移除（整对象比对）
        handleSelect(selection, row) {
            const isSelected = selection.some(item => this.isSameRawRow(item, row))
            const idx = this.multipleSelection.findIndex(item => this.isSameRawRow(item, row))
            if (isSelected) {
                if (idx === -1) {
                    this.multipleSelection.push(row)
                }
            } else if (idx !== -1) {
                this.multipleSelection.splice(idx, 1)
            }
            this.syncMultipleSelectionSummary()
        },
        // 时间
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.getRequestData.end = time;
            }
        },
        // 获取所有凭证方案
        async getAllVoucherPlan() {
            let responseData = await this.$http.getVoucherPlan({ configId: 1 });
            if (responseData.status == 200) {
                this.planList = responseData.result
                this.getRequestData.planId = this.planList[0].planId
                this.groupField = this.planList[0].groupField
                this.getDataList()
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 动作集合
        actionSet(actionData) {
            switch (actionData.actionType) {
                case 21:
                    this.generateVoucher()
                    break;
                case 22:
                    this.out()
                    break;
                case 23:
                    this.exportUnitData()
                    break;
                case 24:    //导出商品资料
                    window.location.href = this.requesUrl + `/voucher/exportGoodsData?ormId=${String(this.ormId)}`
                    break;
                case 25:    //导出数据
                    this.export2Excel()
                    break;
                case 26:    //导出凭证数据
                    this.export3Excel()
                    break;
                case 27:    //异常回写
                    this.writeVoucher()
                    break;
            }
        },
        //获取图片存取的根路径
        imgurl() {
            // console.log(this.$store.getters.getConfig);
            this.requesUrl = this.$store.getters.getConfig.requestUrl;
            this.imgUrl = this.$store.getters.getConfig.imgUrl;
        },
        // 导出单位资料
        exportUnitData() {
            window.location.href = this.requesUrl + `/voucher/exportUnitData?ormId=${String(this.ormId)}`
        },
        //导出
        async out() {
            let newList = []
            this.voucherData.forEach(item => {
                newList.push(this.getmx(item))
            })
            // console.log(newList)
            if (newList.length == 0) {
                return this.$message({
                    message: '暂无凭证可导出',
                    type: "error",
                });
            }
            // this.rawDataIds = []
            if (this.accountSel == 1) {
                let res1 = JSON.parse(JSON.stringify(newList))
                let code = res1[0].Code || "记"
                let ress1 = []
                res1.forEach(item => {
                    // this.rawDataIds.push(item.djbh)
                    delete item.direction
                    delete item.jdfx
                    delete item.djbh
                    delete item.Code
                    delete item.Name
                    delete item.ExternalCode
                    delete item.VoucherDate
                    delete item.id
                    if (item.AmountCr != 0 && item.AmountDr != 0) {
                        ress1.push(item)
                    }
                })
                let hz = {
                    "ExternalCode": this.multipleSelection[0].djbh,
                    "DocType": { "Code": code },
                    "AttachedVoucherNum": res1.length.toString(),
                    "Memo": "无",
                    "VoucherDate": "2014-09-30",
                    "Entrys": ress1,
                    "VoucherDate": this.oldList[0].rq
                }
                this.subAllVoucherInfo(hz)
            }
            if (this.accountSel == 2) {
                for (let index = 0; index < this.multipleSelection.length; index++) {
                    const item = this.multipleSelection[index];
                    console.log(item);

                    // this.rawDataIds = []
                    let mx = newList.filter(resmx => {
                        resmx.djbh == item.djbh
                    })
                    let res2 = JSON.parse(JSON.stringify(newList))
                    let resArr = []
                    let code = res2[0].Code || "记"
                    res2.forEach(key => {
                        if (item.djbh == key.djbh && item.AmountCr != 0 && item.AmountDr != 0) {
                            resArr.push(key)
                            // this.rawDataIds.push(key.djbh)
                        }
                        delete key.direction
                        delete key.jdfx
                        delete key.djbh
                        delete key.Code
                        delete key.Name
                        delete key.ExternalCode
                        delete key.VoucherDate
                        delete key.id
                    })
                    let hz = {
                        "ExternalCode": item.djbh,
                        "DocType": { "Code": code },
                        "AttachedVoucherNum": res2.length,
                        "Memo": "无",
                        "VoucherDate": "2014-09-30",
                        "Entrys": resArr,
                        "VoucherDate": this.oldList[0].rq
                    }
                    let params = {
                        map: hz,
                        planId: this.getRequestData.planId,
                        billNum: [item.djbh],
                        start: this.getRequestData.start,
                        end: this.getRequestData.end,
                    }
                    let responseData = await this.$http.subVoucherInfo(params)
                    if (responseData.status == 200) {
                        if (index == this.multipleSelection.length - 1) {
                            this.$message({
                                message: '导出成功',
                                type: "success",
                            });
                            this.activeName = 'first'
                            this.voucherData = []
                            this.multipleSelection = []
                            this.resList = []
                            this.getDataList()
                        }
                    } else {
                        this.$message({
                            message: responseData.message,
                            type: "error",
                        });
                    }
                }
            }
        },
        // 调用T+接口
        async subAllVoucherInfo(info) {
            let params = {
                map: info,
                planId: this.getRequestData.planId,
                billNum: this.rawDataIds,
                start: this.getRequestData.start,
                end: this.getRequestData.end,
            }
            console.log('调用T+接口', params);
            let responseData = await this.$http.subVoucherInfo(params)
            if (responseData.status == 200) {
                this.$message({
                    message: '导出成功',
                    type: "success",
                });
                this.activeName = 'first'
                this.voucherData = []
                this.multipleSelection = []
                this.resList = []
                this.getDataList()
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 生成凭证
        async generateVoucher() {
            // 判断是否有选中数据
            if (this.multipleSelection.length == 0) {
                return this.$message({
                    message: '请先选中数据',
                    type: "error",
                });
            }
            await this.getDetailsByIds()
            this.resList = []
            //获取转换后明细  20220409改动 最后转换明细
            let mxlist = []
            this.detailsList.forEach(item => {
                mxlist.push(item)
            })
            //只生成一张凭证
            if (this.accountSel == 1) {
                let mx = []
                //合并相同科目
                if (this.mutipleSel.includes('3')) {
                    mx = this.recordSummary(mxlist, this.multipleSelection[0].djbh, 0)
                    this.resList = mx
                } else {
                    this.resList = mxlist
                }
            } else if (this.accountSel == 2) {  //每笔生成一张凭证
                if (this.mutipleSel.includes('3')) {
                    this.multipleSelection.forEach((item, index) => {
                        //合并相同科目
                        let newmx = []
                        if (this.mutipleSel.includes('3')) {
                            newmx = this.recordSummary(mxlist, item.djbh, 1)
                        }
                        this.resList = this.resList.concat(newmx)
                    })
                } else {
                    this.resList = mxlist
                }
            }
            //忽略为0明细
            if (this.mutipleSel.includes('4')) {
                let mx2 = this.resList.filter(item => {
                    return item[item.direction == '贷方' ? 'dfje' : 'jfje'] != 0
                })
                this.resList = this.recordSummary(JSON.parse(JSON.stringify(mx2)));
            }
            this.voucherData = JSON.parse(JSON.stringify(this.resList))
            let df = [], jf = []
            this.voucherData.forEach(keys => {
                if (keys.direction == '借方') {
                    jf.push(keys)
                } else {
                    df.push(keys)
                }
            })
            this.voucherData = jf.concat(df)
            this.rawDataIds = []
            this.multipleSelection.forEach(key => {
                this.rawDataIds.push(key.djbh)
            })
            this.$refs.plTable1.reloadData(this.voucherData)
            this.activeName = 'second'
        },
        recordSummary(arr, djbh, isall) {
            const accKeys = ['jfje', 'dfje'] //number字段
            const searchKeys = this.groupField.split(',') // 合并分组字段
            console.log(searchKeys)
            let list = []
            if (isall == 1) {
                list = arr.filter(item => {
                    return item.djbh = djbh
                })
            } else {
                list = JSON.parse(JSON.stringify(arr))
            }
            // console.log('list',list)
            // const searchKeys = ['kemuhao','auxaccdepartment'] // 合并字段
            const res = list.reduce((pre, cur, i) => {
                const findIndex = pre.findIndex(item => {
                    return searchKeys.reduce((flag, key) => {
                        return flag && item[key] === cur[key]
                    }, true)
                })
                if (findIndex > -1) {
                    const find = pre[findIndex]
                    // console.log(find)
                    if (find['direction'] == '贷方' && cur['direction'] == '贷方') {
                        find.dfje = NP.plus(
                            Number(find.dfje),
                            Number(cur.dfje)
                        );
                        find.dfje = find.dfje.toString()
                        if (cur.quantitycr && !isNaN(Number(cur.quantitycr))) {
                            find.quantitycr = NP.plus(
                                Number(find.quantitycr),
                                Number(cur.quantitycr)
                            );
                            find.quantitycr = find.quantitycr.toString()
                        }
                        // console.log('find', find.dfje,cur)
                    }
                    if (find['direction'] == '借方' && cur['direction'] == '借方') {
                        // console.log('借方',find.jfje,cur,cur.jfje)
                        find.jfje = NP.plus(
                            Number(find.jfje),
                            Number(cur.jfje)
                        );
                        find.jfje = find.jfje.toString()
                        if (cur.quantitydr && !isNaN(Number(cur.quantitydr))) {
                            find.quantitydr = NP.plus(
                                Number(find.quantitydr),
                                Number(cur.quantitydr)
                            );
                            find.quantitydr = find.quantitydr.toString()
                        }
                    }
                } else {
                    pre.push({
                        ...cur
                    })
                }
                return pre
            }, [])
            return res
        },
        //转换凭证明细
        getmx(detail) {
            let da = JSON.parse(JSON.stringify(detail));
            let that = this
            let mx = {}
            let infos = {}
            let jdfx = da.direction == "借方" ? 'jf' : 'df'
            for (let i in da) {
                if (da[i] != null) {
                    da[i] = da[i].toString()
                }
                //判断字段是否需要
                let fld = that.fieldJson.find(item => {
                    return item.dataSource == i && item.groupType == 'mx' && (jdfx == item.jdfx || item.jdfx == 'all')
                })
                if (fld) {
                    if (fld.isAuxInfos) {
                        if (fld.isCode) {
                            infos[fld.voucherField] = { "Code": da[i] }
                        } else {
                            infos[fld.voucherField] = da[i]
                        }
                    } else {
                        if (fld.isCode) {
                            mx[fld.voucherField] = { "Code": da[i] }
                        } else {
                            if (fld.dataSource == 'unitName') {
                                mx[fld.voucherField] = { "Name": da[i] }
                            } else {
                                mx[fld.voucherField] = da[i]
                            }
                        }
                    }
                }
            }
            if (JSON.stringify(infos) != '{}') {
                mx['AuxInfos'] = new Array(infos)
            }
            // console.log('detail',detail)
            //添加转换后明细借贷方向
            mx["direction"] = jdfx
            //添加转换后明细借贷方向
            mx["djbh"] = detail.djbh
            mx["ExternalCode"] = detail.djbh
            mx["VoucherDate"] = detail.rq
            mx["Code"] = detail.pzlx || "记";
            mx["Name"] = detail.jzpz || "记账凭证";
            return mx
        },
        // 获取对应明细
        async getDetailsByIds() {
            this.oldList = []
            var ids = []
            this.oldList = this.multipleSelection //已经选中得数据
            this.multipleSelection.forEach(item => {
                ids.push(item.djbh)
            })
            let params = {
                planId: this.getRequestData.planId,
                ids: ids,
                start: this.getRequestData.start,
                end: this.getRequestData.end,
            }
            let responseData = await this.$http.getDetailsByIds(params)
            if (responseData.status == 200) {
                this.detailsList = responseData.rows
                // console.log('明细', this.detailsList)
                if (this.detailsList.length == 0) {
                    return this.$message({
                        message: '未找到明细',
                        type: "error",
                    });
                }
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
            return this.detailsList
        },
        // 异常回写
        async writeVoucher() {
            if (this.multipleSelection.length == 0) {
                return this.$message({
                    message: '请先选中数据',
                    type: "error",
                });
            }
            var ids = []
            this.multipleSelection.forEach(item => {
                ids.push(item.djbh)
            })
            let params = {
                planId: this.getRequestData.planId,
                ids: ids,
                start: this.getRequestData.start,
                end: this.getRequestData.end,
            }
            let responseData = await this.$http.voucherwriteVoucher(params)
            if (responseData.status == 200) {
                this.$message({
                    message: '回写成功',
                    type: "success",
                });
                this.multipleSelection = []
                this.getDataList()
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        pf(arr) {
            let dwmc = arr[0].dwmch
            for (let index = 0; index < arr.length; index++) {
                if (arr[index].dwmch != dwmc) {
                    return false
                }
            }
            return true
        },
        // 获取数据列表
        async getDataList() {
            this.activeName = 'first'
            this.voucherData = []
            this.resList = []
            let params = JSON.parse(JSON.stringify(this.getRequestData))
            let responseData = await this.$http.getVoucherRawData(params)
            if (responseData.status == 200) {
                this.rawData = responseData.rows
                this.multipleSelection = this.multipleSelection.map(item => {
                    // 在 rawData 中查找相同的项
                    const matchedItem = this.rawData.find(r => this.isSameRawRow(r, item));
                    // 如果找到相同的，用 rawData 中的替换，否则保持原样
                    return matchedItem || item;
                });
                // reloadData 为异步；须在 then 后再 toggle，否则勾选集与单元格不同步
                Promise.resolve(this.$refs.plTable.reloadData(this.rawData)).then(() => {
                    this.$nextTick(() => {
                        const pl = this.$refs.plTable
                        pl.clearSelection();
                        if (pl && this.multipleSelection.length) {
                            pl.toggleRowSelection(
                                this.multipleSelection.map(row => ({ row, selected: true }))
                            )
                        }
                        this.syncMultipleSelectionSummary()
                        var H = document.documentElement.querySelector('.page_content').clientHeight
                        var btnHeight = document.documentElement.querySelector('.page_content').querySelector('.page_content_top').clientHeight
                        var disHeight = document.documentElement.querySelector('.page_content').querySelector('.dis').clientHeight
                        var tabHeight = document.documentElement.querySelector('.page_content').querySelector('.el-tabs__header').clientHeight
                        this.tableHeight = H - (btnHeight + disHeight + tabHeight + 50)
                    })
                })
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 获取权限按钮
        async getButtonList() {
            this.buttonList = await this.$common.getActionButton();
        },

    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        var obj = this.$common.getSearch(this.getRequestData, 'start', 'end', 'page', 'rows', 30)
        for (const key in obj) {
            this.$set(this.getRequestData, key, obj[key])
        }
        this.ormId = sessionStorage.getItem('ormId')
        this.activeName = "first"
        this.imgurl()
        this.getButtonList()
        this.getAllVoucherPlan()
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        this.$nextTick(() => {
            var H = document.documentElement.querySelector('.page_content').clientHeight
            var btnHeight = document.documentElement.querySelector('.page_content').querySelector('.page_content_top').clientHeight
            var disHeight = document.documentElement.querySelector('.page_content').querySelector('.dis').clientHeight
            var tabHeight = document.documentElement.querySelector('.page_content').querySelector('.el-tabs__header').clientHeight
            this.tableHeight = H - (btnHeight + disHeight + tabHeight + 50)
        })
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() { }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style scoped>
.table_content_tag {
    margin-right: 1rem;
}

/* .el-tabs--border-card_new {
    height: 85vh;
    overflow-y: scroll;
} */

.el-drawer {
    outline: none;
}

.dis {
    display: flex;
    align-items: center;
    margin: 10px 0;
}

/* .page_content_center {
    height: 72vh;
} */

.dissp {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.num {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #606266;
    margin-right: 5%;
}

.money {
    margin-left: 50px;
}

.ttred {
    color: red;
}
</style>